import React, {useEffect, useRef, useState} from 'react';

function ThreeDotOptions({
                             elements,
                             onElementClick,
                             isBottomMessage = false,
                             onOpenStateChange = () => {
                             },
                         }) {
    const [isFloatingBarOpen, setIsFloatingBarOpen] = useState(false);
    const [pendingKey, setPendingKey] = useState(null);
    const floatingBarRef = useRef(null);
    const flagRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (pendingKey) {
                return;
            }
            if (
                floatingBarRef.current &&
                !floatingBarRef.current.contains(event.target) &&
                !flagRef.current.contains(event.target)
            ) {
                setIsFloatingBarOpen(false);
                onOpenStateChange(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onOpenStateChange, pendingKey]);

    const handleFlagClick = () => {
        if (pendingKey) {
            return;
        }
        if (isFloatingBarOpen) {
            setIsFloatingBarOpen(false);
            onOpenStateChange(false);
        } else {
            setIsFloatingBarOpen(true);
            onOpenStateChange(true);
        }
    };

    const handleOptionClick = async (key) => {
        try {
            setPendingKey(key);
            const shouldClose = await onElementClick(key);
            if (shouldClose !== false) {
                setIsFloatingBarOpen(false);
                onOpenStateChange(false);
            }
        } finally {
            setPendingKey(null);
        }
    };

    return (
        <div className="position-relative">
            <img
                src="/images/chat-options.svg"
                alt="Chat options"
                className="chat-options"
                onClick={handleFlagClick}
                ref={flagRef}
            />
            {isFloatingBarOpen && (
                <div
                    className={`floating-message-option ${
                        isBottomMessage ? 'above' : ''
                    }`}
                    ref={floatingBarRef}
                >
                    {elements &&
                        Object.entries(elements).map(([key, value]) => (
                            <button
                                key={key}
                                onClick={() => handleOptionClick(key)}
                                disabled={pendingKey !== null}
                            >
                                {pendingKey === key ? 'Working...' : value}
                            </button>
                        ))}
                </div>
            )}
        </div>
    );
}

export default ThreeDotOptions;
